
<mat-drawer-container autosize (backdropClick)="close('backdrop')" [hasBackdrop]="sidenav.opened">
    
    <mat-drawer #sidenav mode="over" position="end">
        <mat-toolbar class="d-flex justify-content-between drawer-header">
            <h6>{{sidenavService.sidenavAction}}</h6>
            <div class="spacer"></div>
            <button mat-mini-fab color="primary" aria-label="Cancel" (click)="sidenavService.close()">
              <fa-icon class="text-white" [icon]="faTimes"></fa-icon> 
            </button>
          </mat-toolbar>
          <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.SearchBusiness">
            <app-search-business></app-search-business>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.SearchParent">
            <app-search-parent></app-search-parent>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.SearchStudent">
            <app-search-student></app-search-student>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.NewParent">
            <app-profile (emitProfile)="loadProfile($event)"></app-profile>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.NewBusiness">
            <app-business-profile (emitProfile)="loadProfile($event)"></app-business-profile>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.NewStudent">
            <app-student-profile [isAdmin]="true" (emitProfile)="loadStudentProfile($event)"></app-student-profile>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.SearchLocation">
            <app-search-location></app-search-location>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.SearchMealPlan">
            <app-search-meal-plan></app-search-meal-plan>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.SearchMeal">
            <app-search-meal></app-search-meal>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.SearchService">
            <app-search-service></app-search-service>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.NewLocation">
            <app-location (emitLocation)="loadLocation($event)"></app-location>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.NewMealPlan">
            <app-meal-plan [context]="'edit'"></app-meal-plan>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.NewMeal">
            <app-meal></app-meal>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.SearchGroup">
            <app-search-group></app-search-group>
        </ng-container> 
        <app-community-group-create *ngIf="sidenav.opened && sidenavService.sidenavAction === sideNavActions.NewCommunityGroup"></app-community-group-create>
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.NewGroup">
            <app-group></app-group>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.NewService">
            <app-service (emitService)="loadService($event)"></app-service>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.SearchPractitioner">
            <app-search-practitioner></app-search-practitioner>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.NewPractitioner">
            <app-practitioner (emitPractitioner)="loadPractitioner($event)"></app-practitioner>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.NewAppointment">
            <app-appointment-form (loading)="loading = $event" [appointment]="sidenavService.newBookingForm" [appointmentAction]="sidenavService.sidenavAction" (openAppointment)="openAppointment($event)"></app-appointment-form>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.UpdateAppointment">
            <app-appointment-form (loading)="loading = $event" [appointment]="sidenavService.newBookingForm" (openAppointment)="openAppointment($event)"></app-appointment-form>
        </ng-container> 
        <ng-container *ngIf="sidenavService.sidenavAction === sideNavActions.ReviewAppointment">
            <app-appointment-form (loading)="loading = $event" [appointment]="sidenavService.reviewBookingForm" [appointmentAction]="sidenavService.sidenavAction" (openAppointment)="openAppointment($event)"></app-appointment-form>
        </ng-container> 
    </mat-drawer>
    <mat-drawer disableClose=true #chatDrawer mode="side" position="start">
        <app-chat (emitClose)="chatDrawer.close()"></app-chat>
      </mat-drawer>
    <mat-drawer-content>
        <div class="main-wrapper">
        <button class="mr-2 fab-bottom-left fab-chat" mat-mini-fab [color]="chatDrawer.opened ? 'accent' : 'primary'" (click)="chatDrawer.toggle()" aria-label="Chat">
            <fa-icon class="text-white" [icon]="faChat"></fa-icon>
        </button>
        <mat-toolbar color="primary" class="d-flex justify-content-between bg-dark text-white">
            <div class="desktop">
                <div class="pl-3 pr-3">
                    <img (click)="website()" class="logo" src="assets/icon.png"/>
                </div>

                <button mat-button routerLink="dashboard" routerLinkActive="active">
                Dashboard
                </button>
                <button mat-button routerLink="appointments" routerLinkActive="active" >
                    Calendar
                </button>
                <!-- <button mat-button routerLink="parents" routerLinkActive="active">
                    Parents
                </button>
                <button mat-button active routerLink="students" routerLinkActive="active">
                    Students
                </button>
                <button mat-button routerLink="teachers" routerLinkActive="active">
                    Teachers
                </button> -->
                <button mat-button routerLink="categories" routerLinkActive="active">
                    Categories
                </button>
                <button mat-button routerLink="community-groups" routerLinkActive="active">
                    Community Groups
                </button>
                <button mat-button routerLink="businesses" routerLinkActive="active">
                    Businesses
                </button>
                <button mat-button routerLink="users" routerLinkActive="active">
                    Users
                </button>
            </div>
            <div class="mobile">
                <div class="pl-3 pr-3 bg-white link" routerLink="dashboard">
                    <img class="logo" src="assets/icon.png"/>
                </div>
            </div>
            <div class="spacer"></div>
            <div class="mobile">
                <!-- <button color="default" class="mr-2"  mat-mini-fab routerLink="appointments" aria-label="Calendar">
                    <fa-icon [icon]="faCalendar"></fa-icon> 
                </button> -->
                <button class="mr-2" *ngIf="businessRequests?.length > 0" mat-mini-fab [matMenuTriggerFor]="notifications" color="default" aria-label="Notifications">
                    <fa-icon [icon]="faBell"></fa-icon> 
                </button>
                <button mat-stroked-button [matMenuTriggerFor]="menu">MENU</button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item routerLink="dashboard" routerLinkActive="active">
                        Dashboard
                        </button>
                        <!-- <button mat-menu-item routerLink="appointments" routerLinkActive="active">
                            Calendar
                        </button> -->
                    <!-- <button mat-menu-item routerLink="parents" routerLinkActive="active">
                        Parents
                    </button>
                    <button mat-menu-item routerLink="students" routerLinkActive="active">
                        Students
                    </button>
                    <button mat-menu-item routerLink="meal-plans" routerLinkActive="active">
                        Meal-plans
                    </button>
                    <button mat-menu-item routerLink="meals" routerLinkActive="active">
                        Meals
                    </button>
                    <button mat-menu-item routerLink="teachers" routerLinkActive="active">
                        Teachers
                    </button> -->
                    <button mat-menu-item routerLink="categories" routerLinkActive="active">
                        Categories
                    </button>
                    <button mat-menu-item routerLink="community-groups" routerLinkActive="active">
                        Community Groups
                    </button>
                    <button mat-menu-item routerLink="businesses" routerLinkActive="active">
                        Businesses
                    </button>
                    <button mat-menu-item routerLink="config" routerLinkActive="active">
                        Config
                    </button>
                    <!-- <button mat-menu-item routerLink="services" routerLinkActive="active">
                        Services
                    </button>
                    <button mat-menu-item routerLink="locations" routerLinkActive="active">
                        Locations
                    </button> -->
                    <button mat-menu-item (click)="logout()">Logout</button>
                </mat-menu>
            </div>
            <div class="desktop">
                <!-- <button color="default" class="mr-2"  mat-mini-fab routerLink="appointments" aria-label="Calendar">
                    <fa-icon [icon]="faCalendar"></fa-icon> 
                </button> -->
                <button color="default" class="mr-2" mat-mini-fab [matMenuTriggerFor]="notifications" aria-label="Notifications">
                    <fa-icon [icon]="faBell"></fa-icon> 
                </button>
                <button mat-button [matMenuTriggerFor]="menu">{{currentUser}}</button>
                <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="logout()">Logout</button>
                </mat-menu>
            </div>
            <mat-menu class="p-2" #notifications="matMenu">
                <div class="p-2 d-flex align-items-center">
                    <!-- <div class="initials">
                      <fa-icon [icon]="faCalendar" class="text-white"></fa-icon> 
                    </div> -->
                    <h4 [matBadge]="businessRequests ? businessRequests.length : 0" matBadgeSize="medium" matBadgeOverlap="false">Requests  </h4>
                </div>
                <div *ngFor="let request of businessRequests" class="d-flex flex-1 link justify-content-start m-2 align-items-center">
                    <div class="flex-1 p-2 border-radius-5" [ngClass]="appointment.cssClass">
                       <p>
                        {{request.title}}
                        </p>
                      <button mat-raised-button  (click)="reviewRequest(appointment)">Review</button>
                    </div>
                  </div> 
                  <app-notifications></app-notifications>
            </mat-menu>

        </mat-toolbar>
        <div class="dashboard-container flex-1">
            <router-outlet></router-outlet>
        </div>
        </div>
    </mat-drawer-content>


    
      <div class="example-sidenav-content">

      </div>
</mat-drawer-container>
